import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const cardsSlider = {
		/**
		 * Equalize visible slide heights for mixed sliders.
		 */
		equalizeMixedHeights: function($slider) {
			if (!$slider.hasClass('js-cards-slider-mixed') || !$slider.hasClass('slick-initialized')) {
				return;
			}

			const slick = $slider.slick('getSlick');
			if (!slick) {
				return;
			}

			const $slides = slick.$slideTrack.children('.slick-slide').not('.slick-cloned');
			const $items = $slides.filter('.cards-slider__item');

			if (!$slides.length || !$items.length) {
				return;
			}

			$slides.css('height', 'auto');
			$items.css('height', 'auto');

			let maxHeight = 0;

			$items.each(function() {
				maxHeight = Math.max(maxHeight, $(this).outerHeight());
			});

			if (!maxHeight) {
				return;
			}

			$slides.css('height', `${maxHeight}px`);
			$items.css('height', `${maxHeight}px`);
			slick.setPosition();
		},

		bindMixedHeightObserver: function($slider) {
			const queueEqualize = function() {
				window.requestAnimationFrame(() => {
					cardsSlider.equalizeMixedHeights($slider);
				});
			};

			$slider.find('img').each(function() {
				if (this.complete) {
					return;
				}

				$(this).one('load', queueEqualize);
			});

			queueEqualize();
		},

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {
			// Default configuration (4 columns)
			const defaultResponsive = [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2
					}
				}
			];

			// 3 column configuration
			const threeColResponsive = [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				}
			];

			// 5 column configuration
			const fiveColResponsive = [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 2
					}
				}
			];

			// mixed configuration
			const mixedResponsive = [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1
					}
				}
			];

			const sliderConfig = {
				autoplay: false,
				infinite: false,
				arrows: true,
				lazyLoad: 'anticipated',
				// Slick drops any swipe that lands while a transition is running,
				// so leaving this on makes a second swipe do nothing.
				waitForAnimate: false,
			};

			// Initialize each slider individually
			$('.js-cards-slider').each(function() {
				const $slider = $(this);
				const $wrapper = $slider.closest('.cards-slider');
				const $progressBar = $wrapper.find('.js-cards-slider-progress');
				const $prevArrow = $wrapper.find('.js-cards-slider-prev');
				const $nextArrow = $wrapper.find('.js-cards-slider-next');

				// Determine column variant
				const is3Col = $slider.hasClass('js-cards-slider-3-col');
				const is5Col = $slider.hasClass('js-cards-slider-5-col');
				const isMixed = $slider.hasClass('js-cards-slider-mixed');

				// Set slides and responsive config based on variant
				let slidesToShow = 4;
				let centerMode = false;
				let responsiveConfig = defaultResponsive;

				if (isMixed) {
					slidesToShow = 3;
					centerMode = false;
					responsiveConfig = mixedResponsive;
				} else if (is3Col) {
					slidesToShow = 3;
					responsiveConfig = threeColResponsive;
				} else if (is5Col) {
					slidesToShow = 5;
					responsiveConfig = fiveColResponsive;
				}

				const config = {
					...sliderConfig,
					slidesToShow: slidesToShow,
					variableWidth: isMixed,
					centerMode: centerMode,
					responsive: responsiveConfig,
					prevArrow: $prevArrow,
					nextArrow: $nextArrow
				};

				// Hide controls when not enough slides to scroll
				$slider.on('init', function(event, slick) {
					const $controls = $wrapper.find('.js-cards-slider-controls');

					if (isMixed) {
						// For variableWidth, compare actual track width vs slider width
						const trackWidth = slick.$slideTrack.children().toArray()
							.reduce(function(sum, el) { return sum + $(el).outerWidth(true); }, 0);
						const sliderWidth = slick.$slider.width();
						if (slick.slideCount <= 1 || trackWidth <= sliderWidth) {
							$controls.addClass('disabled');
							slick.setOption({swipe: false, draggable: false}, false);
						}
					} else if (slick.slideCount <= slick.options.slidesToShow) {
						$controls.addClass('disabled');
					}

					if (isMixed) {
						cardsSlider.bindMixedHeightObserver($slider);
					}
				});

				sliders.initializeSlider($slider, config);

				if (isMixed) {
					$slider.on('lazyLoaded reInit breakpoint afterChange', function() {
						cardsSlider.bindMixedHeightObserver($slider);
					});

					$(window).on('resize.cardsSliderHeight', function() {
						window.clearTimeout($slider.data('cardsSliderResizeTimer'));
						const resizeTimer = window.setTimeout(function() {
							cardsSlider.equalizeMixedHeights($slider);
						}, 150);
						$slider.data('cardsSliderResizeTimer', resizeTimer);
					});
				}

				$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
					if (!$progressBar.length) return;

					const total = slick.slideCount;
					const visible = slick.options.slidesToShow;
					const maxIndex = total - visible;

					if (maxIndex <= 0) {
						$progressBar.css('transform', 'scaleX(1)');
						return;
					}

					const calc = Math.min(nextSlide / maxIndex, 1);
					$progressBar.css('transform', `scaleX(${calc})`);
				});
			});
		},
	};

	cardsSlider.init();

});
